import React, {useEffect, useState} from 'react';
import {Menu} from "antd";
import {useLocation, useNavigate} from "react-router-dom";
import {useMainLayoutContext} from "../../index";
import {Type} from "../../constant/Constant";
import {ActionKeys, SubjectName} from "../../../custom/permission/Ability";
import {AbilityUtil} from "../../../custom/permission/Can";
import "./menu.scss"

function SidebarMenu() {

    const navigate = useNavigate();
    const {pathname} = useLocation();
    const [openKeys, setOpenKeys] = useState(["/hrm/timekeeping/time-sheet/timesheet"]);
    const [rootSubmenuKeys, setRootmenuKeys] = useState([])
    const {siderData, type} = useMainLayoutContext()
    const [sider, setSider] = useState([])


    useEffect(() => {

        if (type !== Type.setting) {
            let cloneSiderData = [...siderData]
            cloneSiderData = cloneSiderData?.filter(item => {
                return AbilityUtil.allow(ActionKeys.READ, item.name, {})
            })
            cloneSiderData = cloneSiderData?.map((item) => {

                switch (item.name) {
                    case SubjectName.tnp:
                        item.children = item?.children?.map(item => {
                            switch (item.key) {

                                default:
                                    return item
                            }
                        })
                        return item
                    default:
                        return item
                }
            })

            setSider([...cloneSiderData])
        } else {
            setSider(AbilityUtil.allow(ActionKeys.SETTING, SubjectName.tnp, {}) ? siderData : null)
        }

        setRootmenuKeys(siderData?.map(item => item.key))
    }, [siderData])

    const onOpenChange = (keys) => {
        const latestOpenKey = keys.find((key) => openKeys.indexOf(key) === -1);
        if (rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
            setOpenKeys(keys);
        } else {
            setOpenKeys(latestOpenKey ? [latestOpenKey] : []);
        }
    };

    useEffect(() => {
        const latestOpenKey = rootSubmenuKeys.find((key) => pathname.includes(key));
        setOpenKeys(latestOpenKey ? [latestOpenKey] : []);
    }, [pathname, rootSubmenuKeys])

    const onClick = ({key}) => {
        navigate(key)
    };

    return (
        <Menu
            onClick={onClick}
            style={{
                border: "none",
                background: "var(--primary-bg)",
                color: "var(--primary-text-color)",
                lineHeight: "var(--primary-line-height)",
            }}
            openKeys={openKeys}
            onOpenChange={onOpenChange}
            selectedKeys={[pathname.split("/")?.slice(0, 5)?.toString()?.replaceAll(",", "/").replaceAll("/add", "").replaceAll("/update", "")]}
            mode="inline"
            className={"sidebar-menu"}
            items={sider}
        />
    );
}

export default SidebarMenu;